module.exports = __webpack_public_path__ + "static/img/5.873b931.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/5.png
// module id = YyhS
// module chunks = 0